import {NotifyPropertyChanged} from '../utils/NotifyPropertyChanged.js';

export class BoxState extends NotifyPropertyChanged<BoxState> {
    private _onTarget = false;
    set onTarget(value) {
        if (value !== this._onTarget) {
            const oldValue = this._onTarget;
            this._onTarget = value;
            this.notifyPropertyChanged('onTarget', this._onTarget, oldValue);
        }
    }
    get onTarget() {
        return this._onTarget;
    }

    private _position: number[] = [];
    set position(value) {
        const oldValue = [...this._position];
        this._position = value;
        this.notifyPropertyChanged('position', this._position, oldValue);
    }
    get position() {
        return this._position;
    }
}
